import moment from "moment";

const isEnumeratedSubdomain = (subdomain) => {
  return (
    subdomain &&
    subdomain.items &&
    subdomain.items.find((x) => x.object.type === "SubdomainEnumeration")
  );
};

const isEnumeratedVariableSet = (variableSet) => {
  return (
    variableSet &&
    variableSet.items &&
    variableSet.items.find((x) => x.object.type === "VariableSetEnumeration")
  );
};

/**
 *
 * @param {Object} item
 * @param {Boolean} combinationsIncludeThisVariable
 * @returns
 */
export const getFilterItemKind = (item, combinationsIncludeThisVariable) => {
  const variable = item.items.find((x) => x.object.type === "Variable");
  const subdomain = item.items.find((x) => x.object.type === "Subdomain");
  const variableSet = item.items.find((x) => x.object.type === "VariableSet");
  const domain =
    variable &&
    variable.items &&
    variable.items.length &&
    variable.items.find((x) => x.object.type === "Domain");
  const domainCode = domain && domain.object && domain.object.code;
  const dataTypeIsString =
    domain &&
    domain.object &&
    domain.object.dataType &&
    domain.object.dataType.toLowerCase() === "string";

  let result;

  if (isEnumeratedSubdomain(subdomain)) {
    result = "enumeratedSubdomain";
  } else if (isEnumeratedVariableSet(variableSet)) {
    result = "enumeratedVariableSet";
  } else if (domainCode === "DT") {
    result = "date-range";
  } else if (domainCode === "STRNG" || dataTypeIsString) {
    result = "string";
  } else {
    result = "number-range";
  }

  if (result !== "enumeratedSubdomain" && result !== "enumeratedVariableSet" && combinationsIncludeThisVariable) {
    result = "enumeratedSubdomain";
  }

  return result;
};

export function formatDate(date, dateFormat = "YYYY-MM-DD") {
  if (!date) {
    return "/* insert-date */";
  }
  return moment(date).format(dateFormat);
}

export function generateShortID() {
  return Math.random().toString(36).slice(-6);
}

export const getDateFormat = (item) => {
  const subdomain = item.items.find((x) => x.object.type === "Subdomain");
  if (!subdomain || !subdomain.items) return; // There may be no facets defined

  const facetCollection = subdomain.items.find(
    (x) => x.object.type === "FacetCollection"
  );
  if (
    !facetCollection ||
    !facetCollection.items ||
    !facetCollection.items.length
  )
    return;

  const facetDateFormat = facetCollection.items.find(
    (x) => x.object.facetType === "dateFormatDISC"
  );
  if (!facetDateFormat) return;

  return facetDateFormat.object.observationValue;
};

export function findCubeStructure(item) {
  if (item.object.type === "CubeStructure") {
    return item;
  } else {
    if (item.items) {
      // check if cube structure exists, it can happen it does not if validity ranges are not valid
      for (let i = 0; i < item.items.length; i += 1) {
        const currentChild = item.items[i];
        const result = findCubeStructure(currentChild);

        if (result !== false) {
          return result;
        }
      }
    }
  }

  return false;
}

export function findCubeLinks(item) {
  let cubeLinks = {};
  if (item.items) {
    for (let i = 0; i < item.items.length; i += 1) {
      if (item.items[i].object.type === "CubeLink") {
        const cubeLinksObj = item.items[i].object;
        cubeLinks[cubeLinksObj.foreignCubeId] = cubeLinksObj;
      }
    }
  }

  return cubeLinks;
}

export const sanitizeSqlAlias = (alias) => {
  return alias?.split(".")?.join("_");
};

export const sanitizeForDataName = (cubeCode) => {
  return cubeCode?.split(".")?.join(""); // just remove dots
};

/**
 * Code of row or column in a cube needs to have leading zeros up to length 4.
 *
 * @param {string} code Code of row or column in a cube
 * @returns {string}
 */
export const padWithZeros = (code) => {
  if (code.length >= 4) {
    return code;
  }
  return code.padStart(4, "0");
};
